module.exports = __webpack_public_path__ + "img/eat_out_02.bb742625.jpg";